const faqTools = {
    toggleAll: function (btn) {
        const wrapper = btn.closest('.js_faq__wrapper')
        wrapper.find('.js_faq__item').each((i, el) => {
            const question = $(el).find('.js_faq__question')
            const answer = $(el).find('.js_faq__answer')

            if (btn.hasClass('active')) {
                question.removeClass('active')
                answer.slideUp(300)
            } else {
                question.addClass('active')
                answer.slideDown(300)
            }
        })

        btn.toggleClass('active')
    },

    toggleItem(question) {
        const wrapper = question.closest('.js_faq__wrapper')
        const btn = wrapper.find('.js_faq__btn')
        const answer = question.next('.js_faq__answer')
        
        question.hasClass('active') ? answer.slideUp(300) : answer.slideDown(300)
        question.toggleClass('active')

        wrapper.find('.js_faq__question.active').length == wrapper.find('.js_faq__question').length ? btn.addClass('active') : btn.removeClass('active')
    }
}

$(document).on('click', '.js_faq__btn', function () {
    faqTools.toggleAll($(this))
})

$(document).on('click', '.js_faq__question', function () {
    faqTools.toggleItem($(this))
})